export default __webpack_public_path__ + "static/media/openProject_color.c20229fb.svg";